import { SerializableObject } from '../../common-react/core';

export class Verification extends SerializableObject {
  public valid: boolean;
  public invalidMessage: string;
}
